var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17C5.36613 17 2 13.6339 2 9.5C2 5.36613 5.36613 2 9.5 2C13.6339 2 17 5.36613 17 9.5C17 13.6339 13.6339 17 9.5 17ZM9.5 2.71424C5.75891 2.71424 2.71424 5.75891 2.71424 9.5C2.71424 13.2411 5.75891 16.2858 9.5 16.2858C13.2411 16.2858 16.2858 13.2411 16.2858 9.5C16.2858 5.75891 13.2411 2.71424 9.5 2.71424Z",
    fill: "#E5EAF9",
    stroke: "#fff",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49998 14.5C7.80948 14.5 6.32381 13.5996 5.61821 12.1798C5.53031 12.003 5.62265 11.7946 5.80671 11.723C5.99008 11.6516 6.19494 11.7433 6.2859 11.9178C6.88253 13.0623 8.1051 13.7858 9.49998 13.7858C10.8949 13.7858 12.1174 13.0623 12.7141 11.9177C12.805 11.7433 13.0099 11.6516 13.1932 11.7229C13.3773 11.7945 13.4696 12.0029 13.3817 12.1798C12.6761 13.5996 11.1905 14.5 9.49998 14.5ZM2.95081 6.28577H16.0492V7.00001H2.95081V6.28577Z",
    fill: "#E5EAF9",
    stroke: "#fff",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8214 10.5714C5.14586 10.5689 3.78812 9.2112 3.78564 7.53565V6.64288H4.50002V7.53565C4.50002 8.81778 5.53927 9.85717 6.8214 9.85717C8.10354 9.85717 9.14279 8.81778 9.14279 7.53565V6.64288H9.85716V7.53565C9.85468 9.2112 8.49695 10.5689 6.8214 10.5714Z",
    fill: "#E5EAF9",
    stroke: "#fff",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1785 10.5714C10.503 10.5689 9.14524 9.2112 9.14276 7.53565V6.64288H9.85714V7.53565C9.85714 8.81778 10.8964 9.85717 12.1785 9.85717C13.4607 9.85717 14.4999 8.81778 14.4999 7.53565V6.64288H15.2143V7.53565C15.2118 9.2112 13.8541 10.5689 12.1785 10.5714Z",
    fill: "#E5EAF9",
    stroke: "#fff",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.a942e12cb3c08bb0237ec697cb7f4683.svg";
export { ForwardRef as ReactComponent };